function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext } from 'react';
import { Row, Col } from 'reactstrap';
import { _translate } from "../../../../services/core";
import { useWorkFlow } from "../../../contexts/workflow";
import Icon from "../../../common/icon";
import StartFlag from "../../../assets/flag-solid";
import EndFlag from "../../../assets/flag-checkered";
var JourneyContext = /*#__PURE__*/React.createContext();
JourneyContext.displayName = 'JourneyContext';
export var useJourney = function useJourney() {
  return useContext(JourneyContext);
};

/**
 * Fonction utilitaire
 */
var useUtils = function useUtils() {
  var _currentQuestion$publ;
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector;
  var currentQuestion = collector.currentQuestion;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    responsesCategorized = _useState2[0],
    setResponsesCategorized = _useState2[1];
  var order = (_currentQuestion$publ = currentQuestion.publicParameters) === null || _currentQuestion$publ === void 0 ? void 0 : _currentQuestion$publ.order;
  order = order ? order.split(',').map(function (el) {
    return el.trim();
  }) : null;

  /**
   * Permet de trier les catégories par rapport aux parents
   *
   * @param {array} categories
   * @param {object} list
   */
  var _sortCategories = function sortCategories(categories, list) {
    // Nous allons ranger les catégories dans leur parent.
    categories.forEach(function (category) {
      if (!category) {
        return;
      }
      if (category.parent) {
        if (!list[category.parent.name]) {
          list[category.parent.name] = category.parent;
        }
        if (!list[category.parent.name].child) {
          list[category.parent.name].child = [];
        }
        var isFound = false;
        list[category.parent.name].child.forEach(function (child) {
          if (child && child.name === category.name) {
            isFound = true;
          }
        });
        if (!isFound) {
          list[category.parent.name].child.push(category);
        }
        _sortCategories([category.parent], list);
      } else {
        if (!list[category.name]) {
          list[category.name] = category;
        }
      }
    });
  };

  /**
   * Les réponses ont leur catégories à l'intérieur,
   * mais on possède aussi une liste de toutes les catégories possibles.
   * Donc on va devoir mixer les deux pour optimiser la mise en place des différentes catégories
   * et de leurs réponses.
   */
  var sortResponsesByCategory = function sortResponsesByCategory() {
    var categories = {};
    var expectedResponses = currentQuestion.expectedResponses;
    expectedResponses.forEach(function (response) {
      if (!response || !response.categories) {
        return;
      }
      response.categories.forEach(function (category) {
        if (!category) return;
        if (!categories[category.name]) {
          categories[category.name] = category;
        }
        if (!categories[category.name].responses) {
          categories[category.name].responses = [];
        }
        var isFound = false;
        categories[category.name].responses.forEach(function (resp) {
          if (!resp) {
            return;
          }
          if (resp.alias === response.alias) {
            isFound = true;
          }
        });
        if (!isFound) {
          categories[category.name].responses.push(response);
        }
      });
    });
    var groupedCategories = {};
    _sortCategories(Object.values(categories), groupedCategories);
    groupedCategories = Object.values(groupedCategories);
    console.log(groupedCategories);
    var sortedCategories = groupedCategories.map(function (category) {
      if (!category) {
        return null;
      }
      var found = false;
      currentQuestion.categories.forEach(function (q_category) {
        if (q_category.name === category.name) {
          found = true;
        }
      });

      // supprimer les doublons dans les catégories enfant ou ceux qui n'ont pas accès
      if (found && category && category.child && category.child.length > 0) {
        category.child = category.child.map(function (childCategory) {
          var isFoundChild;
          currentQuestion.categories.forEach(function (q_category) {
            if (childCategory && q_category.name === childCategory.name) {
              isFoundChild = true;
            }
          });
          return isFoundChild ? childCategory : null;
        });
      }
      return found ? category : null;
    });
    if (order) {
      var structuredElements = order.map(function (alias) {
        var foundElement = null;
        sortedCategories.forEach(function (element) {
          if (!foundElement && element && element.name === alias) {
            foundElement = element;
          }
        });
        return foundElement;
      });
      sortedCategories = structuredElements;
    }
    setResponsesCategorized(sortedCategories);
  };

  /**
   * Permet de créer une ligne
   *
   * @param {string|null} className
   * @returns React.Component
   */
  var VerticaleDashedLine = function VerticaleDashedLine(_ref) {
    var className = _ref.className;
    return /*#__PURE__*/React.createElement("div", {
      className: "stop-line d-flex justify-content-center ".concat(className)
    }, /*#__PURE__*/React.createElement("div", {
      className: "inner"
    }));
  };

  /**
   * Permet de rajouter un arrêt (transport)
   *
   * @param {function} addTransport
   * @param {int} index
   * @returns
   */
  var AddStop = function AddStop(_ref2) {
    var addTransport = _ref2.addTransport,
      index = _ref2.index;
    return /*#__PURE__*/React.createElement(Row, {
      className: "w-90 mx-auto p-0 d-flex justify-content-center"
    }, /*#__PURE__*/React.createElement(Col, {
      sm: "12",
      className: "stop-add color-red-wever my-2 d-flex align-items-center justify-content-center flex-column"
    }, /*#__PURE__*/React.createElement(VerticaleDashedLine, null), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "my-1 d-flex align-items-center add-stop-btn",
      onClick: function onClick() {
        return addTransport(index);
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "plus-circle"
    }), "\xA0\xA0 ", _translate('collectorapp_add_stop_between')), /*#__PURE__*/React.createElement(VerticaleDashedLine, null)));
  };

  /**
   * Permet de rajouter le drapeau à gauche
   *
   * @param {number} index
   * @param {boolean} isBetween
   * @returns
   */
  var Flag = function Flag(_ref3) {
    var index = _ref3.index,
      _ref3$isBetween = _ref3.isBetween,
      isBetween = _ref3$isBetween === void 0 ? false : _ref3$isBetween,
      _ref3$className = _ref3.className,
      className = _ref3$className === void 0 ? null : _ref3$className;
    var JourneyFlag = function JourneyFlag() {
      return /*#__PURE__*/React.createElement(Icon, {
        name: "map-marker-alt",
        className: "marker-pink-wever"
      });
    };
    var classJourneyFlag = 'middle';
    if (index === 0) {
      JourneyFlag = StartFlag;
      classJourneyFlag = 'start';
    } else if (index !== 0 && !isBetween) {
      JourneyFlag = EndFlag;
      classJourneyFlag = 'end';
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "pt-0 journey flag ".concat(className, " ").concat(classJourneyFlag)
    }, /*#__PURE__*/React.createElement(JourneyFlag, {
      className: "journey-flag"
    }));
  };

  /**
   * Layout Journey colonne de gauche
   */
  var LeftCol = function LeftCol(_ref4) {
    var children = _ref4.children,
      className = _ref4.className;
    return /*#__PURE__*/React.createElement(Col, {
      sm: "1",
      className: "col-1 px-0 d-flex align-items-center justify-content-center flag-parent ".concat(className)
    }, children);
  };

  /**
   * Layout Journey colonne de droite
   */
  var RightCol = function RightCol(_ref5) {
    var children = _ref5.children,
      className = _ref5.className;
    return /*#__PURE__*/React.createElement(Col, {
      lg: "8",
      sm: "11",
      className: "col-11 d-flex justify-content-center align-items-center flex-column m-0 p-0 ".concat(className)
    }, children);
  };

  /**
   * Layout Journey Ligne contenant les deux colonnes.
   */
  var RowCentered = function RowCentered(_ref6) {
    var children = _ref6.children;
    return /*#__PURE__*/React.createElement(Row, {
      className: " m-0 p-0 justify-content-lg-center"
    }, children);
  };
  useEffect(function () {
    sortResponsesByCategory();
  }, [currentQuestion]);
  return {
    responsesCategorized: responsesCategorized,
    // element dynamique
    Layout: {
      // Lié au positionnement
      LeftCol: LeftCol,
      RightCol: RightCol,
      RowCentered: RowCentered
    },
    Journey: {
      // lié au fonctionnement ou visuel.
      AddStop: AddStop,
      Flag: Flag,
      VerticaleDashedLine: VerticaleDashedLine,
      Provider: JourneyContext.Provider
    }
  };
};
export default useUtils;